import './style.css'
import ReactDOM from 'react-dom/client'
import { Canvas } from '@react-three/fiber'
import Experience from './Experience.jsx'
import { EffectComposer, Bloom } from '@react-three/postprocessing'



const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(
    <div className='webgl-container'>

    <Canvas
        camera={ {
            fov: 45,
            near: 1,
            far: 100,
            position: [ 0, 0, 10 ]
        } }

        gl={{
            antialias: true,
            alpha: true,
        }}
    >   

        <ambientLight intensity={ 1.2 } color='#ffffff' />
        
        <Experience />

        <EffectComposer>
            <Bloom
                luminanceThreshold={ 0.2 }
                luminanceSmoothing={ 0.9 }
                mipmapBlur
            />
        </EffectComposer>

    </Canvas>
    </div>
)